import Swiper from 'swiper';
import {Navigation} from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';

const DESKTOP_BREAKPOINT = 1280;

const ourTeamSection = {
  swipers: new Map(),

  init() {
    const sections = document.querySelectorAll('[data-our-team-js]');
    if (!sections.length) return;

    sections.forEach((section) => this.update(section));

    window.addEventListener('resize', () => {
      sections.forEach((section) => this.update(section));
    });
  },

  update(section) {
    const isDesktop = window.innerWidth >= DESKTOP_BREAKPOINT;
    if (isDesktop && section.classList.contains('view-grid')) {
      this.destroySwiper(section);
    } else {
      this.initSwiper(section);
    }
  },

  initSwiper(section) {
    if (this.swipers.has(section)) return;

    const el = section.querySelector('.swiper');
    if (!el) return;

    const swiper = new Swiper(el, {
      modules: [Navigation],
      loop: false,
      navigation: {
        nextEl: section.querySelector('.swiper-button-next'),
        prevEl: section.querySelector('.swiper-button-prev'),
      },
      breakpoints: {
        0: {
          slidesPerView: 1,
          spaceBetween: 10,
        },
        512: {
          slidesPerView: 2,
          spaceBetween: 10,
        },
        768: {
          slidesPerView: 3,
          spaceBetween: 10,
        },
        1024: {
          slidesPerView: 3,
          spaceBetween: 20,
        },
      },
    });

    this.swipers.set(section, swiper);
  },

  destroySwiper(section) {
    const swiper = this.swipers.get(section);
    if (!swiper) return;
    swiper.destroy(true, true);
    this.swipers.delete(section);
  },
}

window.addEventListener('load', () => {
  ourTeamSection.init();
});
